import styled from 'styled-components';

export const Wrap = styled.div``;

export const Headline = styled.h1``;
